import script from "./4_progress.vue?vue&type=script&setup=true&lang=ts"
export * from "./4_progress.vue?vue&type=script&setup=true&lang=ts"

import "./4_progress.vue?vue&type=style&index=0&id=b182aa98&lang=css"

const __exports__ = script;

export default __exports__